module.exports = __webpack_public_path__ + "img/album14_21.48287f77.jpg";